import { useMediaMin } from '../components/Media';
import { theme } from '../styles';

export const renderResponsiveIcon = (size: (number | string)[]) => {
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  const isTablet = useMediaMin(theme.breakpoint.md);

  if (Array.isArray(size)) {
    if (isDesktop) {
      return size[2];
    } else if (isTablet) {
      return size[1];
    }
    return size[0];
  }
  return 0;
};
